import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, Inject } from '@angular/core';
import { ResourceReference } from '@ispm/core/classes/resource-reference.class';
import { PlaceholderChildComponent } from '@ispm/layout/classes/placeholder-child-component.abstract';
import { IoptionElemet } from '@ispm/shared/interfaces/IoptionElemet';
import { TestActionsService } from '@ispm/test/services/test-actions.service';
import { modalResponse } from '@ispm/layout/constants/modal-responses.enum';
import { TestService } from '@ispm/dashboard/test/services/test.service';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';

@Component({
  selector: 'gen-dynamic-specimen',
  templateUrl: './dynamic-specimen.component.html',
  styleUrls: ['./dynamic-specimen.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class DynamicSpecimenComponent extends PlaceholderChildComponent implements OnInit {
  callback: (...args) => void;
  updateChanges: boolean;
  public payload: {
    testId: string,
    revisionId: string,
    formName: string,
    aberrationType: string,
    orderId: string,
    sampleType: string,
    specimenType: string,
    popupMode: boolean,
    options: IoptionElemet[],
    overrides?: any,
    isFieldsRequired?: boolean
  };
  @Input() specimenType: any;
  @Input() overrides: any;
  @Input() sampleType: string;
  @Input() markAsPrimaryEnabled: boolean;
  @Input() proceedToAnaliseStarted: boolean;
  @Input() editMode: boolean;
  @Input() disabledForced: boolean;
  @Input() title: string;
  @Input() index: number;
  @Input() formId: string;
  @Input() sample: any;
  @Input() isSubmitted: any;
  @Input() isValid: any;
  testSpecimenStatus: boolean;
  @Input()
  set contextReferences(contextObject: ResourceReference[]) {
    if (!this.editMode) {
      return;
    }

    contextObject.forEach(context => {
      this.updatedFieldsContext += `${context.reference},`;
      this.updatedFieldsContextType += `${context.resourceType},`;
    });
  }
  @Input() form: any = { };
  @Output() OnCallback: EventEmitter<any> = new EventEmitter<any>();
  @Output() OnPrimarySet: EventEmitter<any> = new EventEmitter<any>();

  public updatedFieldsContext: string = '';
  public updatedFieldsContextType: string = '';
  public popupMode: boolean = false;
  private testId: string;
  private revisionId;
  private newSpecimen: boolean;
  constructor(
    private testActionsService: TestActionsService,
    private notificationMessageService: NotificationMessageService,
    private TestService : TestService
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();

    if (!this.sample) {
      this.sample = { };
      this.newSpecimen = true;
    }

    this.extractPropertiesFromPayload();

    this.sample.objectType = this.sample.objectType || this.specimenType;
    this.sample.sampleType = this.sample.sampleType || this.sampleType;
    this.sample.isPrimary = this.sample.isPrimary === undefined ? false : this.sample.isPrimary;
    this.updateChanges = this.editMode && true;
  }

  extractPropertiesFromPayload() {
    if (this.payload) {
      if (this.payload.formName) {
        this.formId = this.payload.formName;
      }

      if (this.payload.testId) {
        this.testId = this.payload.testId;
      }

      if (this.payload.revisionId) {
        this.revisionId = this.payload.revisionId;
      }

      if (this.payload.orderId) {
        this.sample.Order = this.payload.orderId;
      }

      if (this.payload.sampleType) {
        this.sample.sampleType = this.payload.sampleType;
      }

      if (this.payload.specimenType) {
        this.sample.objectType = this.payload.specimenType;
      }

      if (this.payload.popupMode) {
        this.popupMode = this.payload.popupMode;
      }

      if (this.payload.overrides) {
        this.overrides = this.payload.overrides;
      }

      if(this.payload.isFieldsRequired !== undefined){
        this.sample.isFieldsRequired = this.payload.isFieldsRequired;
      }
    }
  }

  updateValidate(valid: boolean) {
    this.isValid = valid;
    this.testSpecimenStatus = valid;
  }

  markSpecimenAsPrimary(model) {
    if (this.isValid) {
      const workflowRequestId = this.sample.context.find(currContext => currContext.resourceType === 'WorkflowId');
      this.OnPrimarySet.emit({
        sampleId: this.sample.id,
        sampleType: this.sample.sampleType,
        workflowRequest: workflowRequestId.reference
      });
    }
    else {
      this.notificationMessageService.warning('Invalid sample data');
    }
  }

  updateForm(update) {
    delete update.form.meta;
    Object.assign(this.sample, update.form);

    if (this.isValid || !this.newSpecimen) { //Saving changes even if mandatory data is missing in case of editing a new specimen
      this.OnCallback.emit({ sample: this.sample});
    }
  }

  beforeClose(_modalResponse: modalResponse) {
    if (_modalResponse !== modalResponse.approve) {
      return;
    }

    this.form.$submitted = true;

    return { isValid: this.isValid, sample: this.sample};
  }
}
